// This file was generated by org.multipaz.processor.CodeBuilder, do not edit by hand
package org.multipaz.wallet.shared

import org.multipaz.cbor.DataItem
import org.multipaz.wallet.shared.WalletBackendException
import org.multipaz.cbor.Cbor
import kotlinx.io.bytestring.ByteString
import org.multipaz.cbor.annotation.CborSerializableGenerated
import org.multipaz.wallet.shared.WalletBackendAlreadySignedInException
import org.multipaz.wallet.shared.WalletBackendEncryptionKeyMismatchException
import org.multipaz.wallet.shared.WalletBackendIdTokenException
import org.multipaz.wallet.shared.WalletBackendNonceException
import org.multipaz.wallet.shared.WalletBackendNotSignedInException
import org.multipaz.wallet.shared.WalletBackendVerificationLinkExpiredException
import org.multipaz.wallet.shared.WalletBackendSharedDataTooLargeException

fun WalletBackendException.toCbor(): ByteArray {
    return Cbor.encode(toDataItem())
}

@CborSerializableGenerated(schemaId = "y0mPQBYBxYsSUISabmRBIIs0XmRc6kqrYN2wwZIVJno")
val WalletBackendException_cborSchemaId = ByteString(-53, 73, -113, 64, 22, 1, -59, -117, 18, 80, -124, -102, 110, 100, 65, 32, -117, 52, 94, 100, 92, -22, 74, -85, 96, -35, -80, -63, -110, 21, 38, 122)

fun WalletBackendException.Companion.fromCbor(data: ByteArray): WalletBackendException {
    return WalletBackendException.fromDataItem(Cbor.decode(data))
}

val WalletBackendException.Companion.cborSchemaId: ByteString
    get() = WalletBackendException_cborSchemaId

fun WalletBackendException.toDataItem(): DataItem {
    return when (this) {
        is WalletBackendAlreadySignedInException -> (this as WalletBackendAlreadySignedInException).toDataItem()
        is WalletBackendEncryptionKeyMismatchException -> (this as WalletBackendEncryptionKeyMismatchException).toDataItem()
        is WalletBackendIdTokenException -> (this as WalletBackendIdTokenException).toDataItem()
        is WalletBackendNonceException -> (this as WalletBackendNonceException).toDataItem()
        is WalletBackendNotSignedInException -> (this as WalletBackendNotSignedInException).toDataItem()
        is WalletBackendVerificationLinkExpiredException -> (this as WalletBackendVerificationLinkExpiredException).toDataItem()
        is WalletBackendSharedDataTooLargeException -> (this as WalletBackendSharedDataTooLargeException).toDataItem()
    }
}

fun WalletBackendException.Companion.fromDataItem(dataItem: DataItem): WalletBackendException {
    val type = dataItem["type"].asTstr
    return when (type) {
        "WalletBackendAlreadySignedInException" -> WalletBackendAlreadySignedInException_fromDataItem(dataItem)
        "WalletBackendEncryptionKeyMismatchException" -> WalletBackendEncryptionKeyMismatchException_fromDataItem(dataItem)
        "WalletBackendIdTokenException" -> WalletBackendIdTokenException_fromDataItem(dataItem)
        "WalletBackendNonceException" -> WalletBackendNonceException_fromDataItem(dataItem)
        "WalletBackendNotSignedInException" -> WalletBackendNotSignedInException_fromDataItem(dataItem)
        "WalletBackendVerificationLinkExpiredException" -> WalletBackendVerificationLinkExpiredException_fromDataItem(dataItem)
        "WalletBackendSharedDataTooLargeException" -> WalletBackendSharedDataTooLargeException_fromDataItem(dataItem)
        else -> throw IllegalArgumentException("wrong type: $type")
    }
}
